import React, {useState, useEffect} from "react";
import { Row, Col, Slider } from "antd";

const BarInput: React.FC<any> = ({
  value = undefined,
  placeholder,
  options,
  onChange,
}) => {
  const sliderIndicatorStyle = {
    marginLeft: 10,
    fontSize: "medium",
  };

  const [barConfig, setBarConfig] = useState(
    {
      options: [options[0], options[1], options[2]],
      value: value,
    } || {
      options: [100, 0, 5],
      value: 0,
    }
  );

  useEffect(() => {
    setBarConfig({
      options: [options[0], options[1], options[2]],
      value: value,
    });
  }, []);

  return (
    <div className="tiles padding-12">
      <span className="col-label">{placeholder}</span>
      <Row className="mt-2 w-100">
        <Col span={24}>
          <Slider
            marks={{
              [barConfig.options[1]]: {
                style: sliderIndicatorStyle,
                label: <strong>{barConfig.options[1]}</strong>,
              },
              [barConfig.options[0]]: {
                style: sliderIndicatorStyle,
                label: <strong>{barConfig.options[0]}</strong>,
              },
            }}
            value={value}
            max={barConfig.options[0]}
            min={barConfig.options[1]}
            step={barConfig.options[2]}
            onChange={(value) => {
              onChange(value);
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default BarInput;
